import AbstractScene from './AbstractScene.js';
import { TextContents } from '../consts/TextContents.js';
import { Colors } from '../consts/Colors.js';
import Casier from '../prefabs/obstacles/Casier.js';
import Dcp from '../prefabs/obstacles/Dcp.js';
import FiletMaillant from '../prefabs/obstacles/FiletMaillant.js';
import Palangre from '../prefabs/obstacles/Palangre.js';
import ResteSenne from '../prefabs/obstacles/ResteSenne.js';
import Player from '../prefabs/Player.js';
import ParallaxLayer from '../prefabs/ParallaxLayer.js';


export default class Test extends AbstractScene {
    constructor() {
        super({
            key: "Test"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.upKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
        this.downKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN);
    }

    create() {
        const laneOne = 215
        const laneTwo = 360
        const laneThree = 505
        const laneFour = 650
        const laneFive = 795
        const turtleLane = 598

        this.anims.create({
            key: 'turtleAnim',
            frames: this.anims.generateFrameNumbers('tortue', { start: 0, end: 10 }),
            frameRate: '11',
            repeat: -1
        });

        this.anims.create({
            key: 'turtleNetAnim',
            frames: this.anims.generateFrameNumbers('tortueNet', { start: 0, end: 10 }),
            frameRate: 11,
            repeat: -1
        });

        this.anims.create({
            key: 'filetAnim',
            frames: this.anims.generateFrameNumbers('filetMaillantSprite', { start: 0, end: 1 }),
            frameRate: 2,
            repeat: -1
        });

        this.background = this.add.image(0, 0, 'backMenu').setOrigin(0)

        this.parallaxLayerBulles = new ParallaxLayer(this, 0, -400, 475)
        this.parallaxLayerBulles.addTexture('bulles')
        this.parallaxLayerBulles.addTexture('bulles')
        this.tweens.add({
            targets: this.parallaxLayerBulles,
            y: this.parallaxLayerBulles.y+ 20,
            duration: 1000,
            repeat: -1,
            yoyo: true
        })

        // this.add.line(0, laneOne, 0, 0, this.sys.game.config.width, 0, 0xffffff).setOrigin(0, 0.5);
        // this.add.line(0, laneTwo, 0, 0, this.sys.game.config.width, 0, 0xffffff).setOrigin(0, 0.5);
        // this.add.line(0, laneThree, 0, 0, this.sys.game.config.width, 0, 0xffffff).setOrigin(0, 0.5);
        // this.add.line(0, laneFour, 0, 0, this.sys.game.config.width, 0, 0xffffff).setOrigin(0, 0.5);
        // this.add.line(0, laneFive, 0, 0, this.sys.game.config.width, 0, 0xffffff).setOrigin(0, 0.5);



        // this.obstacle1 = new Casier(this, 100, laneFive, { showHitbox: true }) //ça marche
        // this.obstacle2 = new Dcp(this, 100, laneTwo, { showHitbox: true })
        // // this.obstacle3 = new FiletMaillant(this, 1200, laneTwo, { showHitbox: true })
        // this.texture = this.add.sprite(1200, laneTwo, 'filetMaillantSprite').setOrigin(0.5)
        // this.texture.anims.play('filetAnim');
        // this.obstacle4 = new Palangre(this, 800, laneOne, { showHitbox: true })
        // this.obstacle5 = new ResteSenne(this, 600, laneFive, { showHitbox: true })

        this.turtle = new Player(this, 150, turtleLane, { level: 0, showHitbox: true, })

        this.upKey.on('down', (event) => {
            this.turtleMoveUp()
        })
        this.downKey.on('down', (event) => {
            this.turtleMoveDown()
        })

    }

    turtleMoveUp() {
        if (this.currentLane !== 1) {
            this.add.tween({
                targets: this.turtle,
                duration: 80,
                y: this.turtle.y - 145,

            })
        }
    }
    turtleMoveDown() {
        if (this.currentLane !== 5) {
            this.add.tween({
                targets: this.turtle,
                duration: 80,
                y: this.turtle.y + 145,

            })
        }
    }
}